import { useState, useEffect } from 'react';
import { CookiebotConsent, subscribeToCookiebotConsent } from 'utils/helpers/cookiebot';

interface UseCookieConsentReturn {
  statistics: boolean;
  method: string;
  allCookiesAccepted: boolean;
  consent: CookiebotConsent | null;
}

/*
Reads Cookiebot consent reactively. The subscription covers CookiebotOnAccept,
CookiebotOnDecline and CookiebotOnConsentReady (the returning-visitor case), and
falls back to polling while the Cookiebot script has not loaded yet.
*/
export const useCookieConsent = (): UseCookieConsentReturn => {
  const [consent, setConsent] = useState<CookiebotConsent | null>(null);

  useEffect(() => subscribeToCookiebotConsent(setConsent), []);

  const allCookiesAccepted = consent
    ? consent.necessary && consent.preferences && consent.statistics && consent.marketing
    : false;

  return {
    statistics: consent?.statistics ?? false,
    method: consent?.method ?? '',
    allCookiesAccepted,
    consent,
  };
};
